import { collection, getDocs, getFirestore, limit, onSnapshot, orderBy, query } from "firebase/firestore";
import notificationConverter from "../converters/notificationConverter";
import { Notification } from "../types/Notification";

export const queryNotifications = (idNumber: string, onSnapshotNotifications: (notifications: Notification[]) => void) => {
  const db = getFirestore();
  const q = query(collection(db, `Employees/${idNumber}/Notifications`), orderBy('dateCreated', 'desc'), limit(10)).withConverter(notificationConverter);
  return onSnapshot(q, (qSnapshot) => {
    onSnapshotNotifications && onSnapshotNotifications(qSnapshot.docs.map((d) => d.data()));
  });
};